var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--thin"},[_c('global-message',{attrs:{"value":_vm.data.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }